<script>
  import { hooksStore } from "../../../stores/hooks.store";
  import { tempStore } from "../../../stores/temp.store";

  import { onDestroy } from "svelte";
  import { get as get_store } from "svelte/store";
  import get from "get-value";
  import set from "set-value";

  import Header from "./Header.svelte";
  import Table from "./Table.svelte";

  let open = false;

  hooksStore.addAction("zobrazDatagrid", "Datagrid.svelte", zobrazDatagrid);
  hooksStore.addAction("skryDatagrid", "Datagrid.svelte", skryDatagrid);

  async function zobrazDatagrid(changeSplit = true) {
    let store = get_store(tempStore);
    let spliteResized = get(store, "spliteResized");

    hooksStore.doAction("unhideSplit");
    open = true;
    hooksStore.doAction("zobrazDatagridTabulku", true);
    // ak sa ma menit pomer mapy a datagridu, tak sa to musi prepocitat
    // menim iba ak to chcem a predtym som nemenil velkost rucne
    if (changeSplit && spliteResized != true) {
      const contentLayout = document.querySelector(".content--layout");
      const fullHeight = contentLayout.offsetHeight;
      const max_datagrid_height = fullHeight / 3;

      // musim chvilocku pockat, kym sa datagrid zobrazi aby som mohol ziskat vysku tabulky
      setTimeout(() => {
        const tableHeight = document.querySelector(
          ".content--layout .splitter .panel2 .table__wrapper table"
        ).offsetHeight;
        const tablePagination = document.querySelector(
          ".content--layout .splitter .panel2 .table__wrapper .pagination"
        );
        const tablePaginationHeight = tablePagination
          ? tablePagination.offsetHeight
          : 0;
        const tableAndPaginationHeight = tableHeight + tablePaginationHeight;
        if (
          tableAndPaginationHeight > 0 &&
          tableAndPaginationHeight > max_datagrid_height
        ) {
          hooksStore.doAction("setSplitSize", [66, 34]);
        } else if (tableAndPaginationHeight > 0) {
          const datagridHeight = parseInt(
            ((tableAndPaginationHeight + 55) / fullHeight) * 100
          );
          hooksStore.doAction("setSplitSize", [
            100 - datagridHeight,
            datagridHeight,
          ]);
        }
      }, 10);
    }
  }

  function skryDatagrid() {
    hooksStore.doAction("collapseSplit");
    open = false;
    // zrusim info v temp, ze som menil velkost datagridu rucne,
    // kedze datagrid zatvaram
    let store = get_store(tempStore);
    set(store, "spliteResized", false);
    tempStore.set(store);
  }
</script>

<div class="datagrid" class:open>
  <!-- Panel start  -->
  <Header />
  <Table />
  <!-- Panel end  -->
</div>

<style>
  .datagrid {
    display: none;
    height: 100%;
  }
  .datagrid.open {
    display: flex;
    flex-direction: column;
  }
</style>
